var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCarousel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#A1CDEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2324 17.1585C25.2286 17.6343 25.0398 18.0899 24.7059 18.429L15.9152 27.2197C15.5722 27.5642 15.1063 27.7584 14.6201 27.7595C14.1339 27.7606 13.6672 27.5684 13.3226 27.2254C12.9781 26.8824 12.7839 26.4165 12.7828 25.9303C12.7817 25.4441 12.9739 24.9774 13.3169 24.6329L20.8142 17.1356L13.3169 9.63826C13.147 9.46765 13.0124 9.26525 12.9208 9.04263C12.8292 8.82001 12.7823 8.58153 12.7828 8.34079C12.7834 8.10005 12.8313 7.86177 12.9239 7.63955C13.0165 7.41734 13.152 7.21554 13.3226 7.04569C13.4932 6.87584 13.6956 6.74127 13.9183 6.64963C14.1409 6.558 14.3794 6.5111 14.6201 6.51163C14.8608 6.51217 15.0991 6.56012 15.3213 6.65274C15.5436 6.74536 15.7453 6.88083 15.9152 7.05144L24.7059 15.8421C24.8767 16.0155 25.0113 16.2213 25.1017 16.4473C25.1921 16.6733 25.2365 16.9151 25.2324 17.1585Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCarousel);
export default __webpack_public_path__ + "static/media/arrow_carousel.ee596d758edab942abb7a9fb5b60865c.svg";
export { ForwardRef as ReactComponent };